import { useEffect } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as dayjs from 'dayjs';
import { AWS_BUCKET_URL } from 'toolkit/constants';
import { setLanguageCode } from 'toolkit/utils';
import 'dayjs/locale/en';
import 'dayjs/locale/tr';
import 'dayjs/locale/fa';
import { useDispatch } from 'react-redux';
import { fetchCompetitorsNameByLanguage, setSelectedLocale } from 'stores/match';

const en = `${AWS_BUCKET_URL}/Icons/127.png`;
const de = `${AWS_BUCKET_URL}/Icons/126.png`;
const tr = `${AWS_BUCKET_URL}/Icons/128.png`;
const nl = `${AWS_BUCKET_URL}/Icons/nl.png`;
const bg = `${AWS_BUCKET_URL}/Icons/bulgaria.png`;
const fr = `${AWS_BUCKET_URL}/Icons/france.png`;
const pt = `${AWS_BUCKET_URL}/Icons/portugal.png`;
const es = `${AWS_BUCKET_URL}/Icons/es.png`;
const zh = `${AWS_BUCKET_URL}/Icons/cn.png`;
const fa = `${AWS_BUCKET_URL}/Icons/iran.png`;

const languages = [
  {
    label: 'English',
    shortLabel: 'EN',
    id: 'en-US',
    icon: en
  },
  {
    label: 'Turkce',
    shortLabel: 'TR',
    id: 'tr-TR',
    icon: tr
  },
  {
    label: 'Deutsch',
    shortLabel: 'DE',
    id: 'de-DE',
    icon: de
  },
  {
    label: 'Dutch',
    shortLabel: 'NL',
    id: 'nl-NL',
    icon: nl
  },
  {
    label: 'Bulgarian',
    shortLabel: 'BG',
    id: 'bg-BG',
    icon: bg
  },
  {
    label: 'French',
    shortLabel: 'FR',
    id: 'fr-FR',
    icon: fr
  },
  // {
  //   label: 'Portuguese',
  //   shortLabel: 'PT',
  //   id: 'pt-PT',
  //   icon: pt
  // },
  // {
  //   label: 'Español',
  //   shortLabel: 'ES',
  //   id: 'es-ES',
  //   icon: es
  // },
  {
    label: '中文',
    shortLabel: 'ZH',
    id: 'zh-ZH',
    icon: zh
  },
  {
    label: 'فارسی',
    shortLabel: 'FA',
    id: 'fa-IR',
    icon: fa
  }
];

const Language = (props) => {
  const { isDesktop } = props;
  const dispatch = useDispatch();
  const { i18n } = useTranslation('translations');
  const currentLanguageOption =
    languages.find((l) => l.id.split('-')[0] === i18n.language) || languages[0];

  useEffect(() => {
    languageChanged(currentLanguageOption);
  }, [i18n.language]);

  function languageChanged(language) {
    if (!language) return;
    const selectedLanguageOption = languages.find((l) => l.id === language.id);
    dispatch(fetchCompetitorsNameByLanguage(selectedLanguageOption));
    dispatch(setSelectedLocale(selectedLanguageOption.id.split('-')[0]));
    setLanguageCode(selectedLanguageOption.id);
    dayjs.locale(selectedLanguageOption.id.split('-')[0]);
  }

  if (!currentLanguageOption) return null;

  return (
    <Dropdown className="language-dropdown" align="end">
      <Dropdown.Toggle
        variant="link"
        id="dropdown-basic"
        className={`text-decoration-none text-white no-arrow d-flex align-items-center ${
          isDesktop ? 'p-0' : 'pb-3'
        }`}>
        <img src={currentLanguageOption.icon} className="me-2" alt="Language" />
        <span>{currentLanguageOption.shortLabel}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {languages.map((lang) => (
          <Dropdown.Item
            key={lang.id}
            as={Button}
            onClick={() => i18n.changeLanguage(lang.id.split('-')[0])}>
            <img src={lang.icon} alt="" className="me-2" />
            <span>{lang.label}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Language;
